"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var colorsEnum = {
  ORANGE: 'orange',
  VIOLET: 'violet',
  BLUE: 'blue',
  LIGHT_BLUE: 'lightBlue',
  GREEN: 'green',
  LIGHT_GREEN: 'lightGreen',
  GREY: 'grey'
};
var _default = colorsEnum;
exports.default = _default;